import { render, staticRenderFns } from "./CertificationAddForm.vue?vue&type=template&id=3e16d61b&scoped=true&"
import script from "./CertificationAddForm.vue?vue&type=script&lang=ts&"
export * from "./CertificationAddForm.vue?vue&type=script&lang=ts&"
import style0 from "./CertificationAddForm.vue?vue&type=style&index=0&id=3e16d61b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e16d61b",
  null
  
)

export default component.exports